import PropTypes from "prop-types";
import Wrapper from "../../components/helpers/Wrapper";

const UnknownGenderIcon = ({ className, percentage }) => {
  const percent_string =
    +Math.abs(percentage).toFixed(2).replace(/\.0$/, "") + "%";
  const fill =
    +Math.abs(100 - percentage)
      .toFixed(2)
      .replace(/\.0$/, "") + "%";

  let bodyFill;

  bodyFill = (
    <Wrapper>
      {percentage > 49 ? (
        <Wrapper>
          <stop offset={percent_string} stopColor="#5A75F9" />
          <stop offset={fill} stopColor="#CEDFE8" />
        </Wrapper>
      ) : percentage < 25 ? (
        <Wrapper>
          <stop offset={fill} stopColor="#CEDFE8" />
          <stop offset={percent_string} stopColor="#CEDFE8" />
        </Wrapper>
      ) : (
        <Wrapper>
          <stop offset={percent_string} stopColor="#5A75F9" />
          <stop offset={"20%"} stopColor="#CEDFE8" />
          <stop offset={"20%"} stopColor="#CEDFE8" />
          <stop offset={"20%"} stopColor="#CEDFE8" />
          <stop offset={"20%"} stopColor="#CEDFE8" />
        </Wrapper>
      )}
    </Wrapper>
  );

  let headFill;

  if (percentage > 10) {
    headFill = "#5A75F9";
  } else {
    headFill = "#CEDFE8";
  }

  return (
    <Wrapper>
      <svg
        className={className}
        viewBox="0 0 18 35"
        height="350px" width="200px"
        xmlns="http://www.w3.org/2000/svg"
      >
        <defs>
          <linearGradient
            id="unknowngradientFill"
            gradientTransform="rotate(90)"
          >
            {bodyFill}
          </linearGradient>
        </defs>
        <path
          fill="url('#unknowngradientFill')"
          d="M4.70909 33.0188C4.33409 32.6118 4.1771 26.4049 4.1771 23.8469V18.6467H4.10008C3.84208 19.3317 3.60007 20.0245 3.31907 20.6975C3.22056 20.9615 3.0427 21.1881 2.80992 21.3469C2.57713 21.5058 2.30086 21.5888 2.01908 21.5842C1.74498 21.6007 1.47208 21.5361 1.23435 21.3987C0.996628 21.2612 0.804534 21.0566 0.682047 20.8108C0.586794 20.6456 0.528536 20.4616 0.511271 20.2717C0.494006 20.0818 0.51817 19.8909 0.582072 19.7112C1.3394 17.4065 2.09671 15.1012 2.85404 12.7952C3.07204 12.1422 3.28505 11.4891 3.50205 10.8411C3.57959 10.4659 3.7915 10.1324 4.09794 9.90259C4.40438 9.67276 4.78423 9.56242 5.16606 9.59302C5.62906 9.59302 7.34904 9.67701 8.63004 9.67701C9.88004 9.67701 11.2711 9.66938 11.6591 9.66138C11.9437 9.61984 12.2339 9.64117 12.5091 9.72486C12.6421 9.79536 12.7585 9.89355 12.8503 10.0129C12.9421 10.1323 13.0071 10.2705 13.0411 10.4172C14.2411 13.3292 15.4454 16.2394 16.6541 19.1487C16.744 19.4115 16.7703 19.6921 16.7311 19.967C16.637 20.2357 16.4812 20.4786 16.2761 20.676C16.1422 20.8169 15.9766 20.9242 15.7932 20.9885C15.6098 21.0529 15.4136 21.0725 15.221 21.0461C15.0291 21.0199 14.8463 20.9477 14.688 20.8362C14.5296 20.7246 14.4004 20.5774 14.3111 20.4055C14.1581 20.1515 14.0291 19.882 13.8481 19.636C14.0741 21.009 14.2911 20.5824 14.5251 21.9514C14.5692 22.1026 14.5761 22.2618 14.5453 22.4163C14.5145 22.5707 14.4468 22.7155 14.3481 22.8381C14.2495 22.9616 14.1225 23.0596 13.978 23.1233C13.8335 23.187 13.6757 23.2148 13.518 23.2044C13.063 23.2254 12.6001 23.2284 12.1361 23.2044C11.8141 23.1874 11.7051 23.2685 11.7091 23.6155C11.7291 25.5085 11.7171 29.8857 11.7171 31.7747C11.7172 31.9672 11.7052 32.1598 11.6811 32.3508C11.6539 32.7121 11.4884 33.0491 11.219 33.2913C10.9496 33.5335 10.5972 33.6629 10.2351 33.6516H10.0821C9.71127 33.6249 9.36569 33.4536 9.11949 33.1751C8.87328 32.8965 8.74604 32.5327 8.76505 32.1614C8.75705 30.1154 8.76505 27.3881 8.76505 25.3381C8.75805 24.2771 8.80105 23.5796 8.40605 23.2776C8.14505 23.1126 7.65405 23.0156 7.23405 23.6946C7.25005 26.2196 7.24604 28.9664 7.24204 31.4944C7.28199 31.9467 7.16806 32.3991 6.91868 32.7786C6.66931 33.1581 6.29914 33.4424 5.86808 33.5852C5.66808 33.6492 6.36809 33.6848 6.15409 33.6848C5.88093 33.6761 5.61226 33.6127 5.36405 33.4983C5.11585 33.3839 4.89315 33.2208 4.70909 33.0188V33.0188Z"
          style={{ transform: "translateY(-0.8px)" }}
        />
        <path
          fill={headFill}
          d="M4.50806 4.64699C4.52398 3.54572 4.97236 2.49488 5.7564 1.72136C6.54044 0.94784 7.59723 0.513687 8.69862 0.512636C9.8 0.511586 10.8576 0.943723 11.6431 1.71575C12.4286 2.48777 12.879 3.53775 12.8971 4.63899C12.8831 5.74818 12.4323 6.80711 11.6424 7.58594C10.8525 8.36477 9.78733 8.80066 8.67805 8.79899C7.57505 8.79953 6.51681 8.36283 5.73519 7.58458C4.95356 6.80633 4.51229 5.74998 4.50806 4.64699"
        />
        <path
          fill={headFill}
          d="M4.50806 4.64699C4.52398 3.54572 4.97236 2.49488 5.7564 1.72136C6.54044 0.94784 7.59723 0.513687 8.69862 0.512636C9.8 0.511586 10.8576 0.943723 11.6431 1.71575C12.4286 2.48777 12.879 3.53775 12.8971 4.63899C12.8831 5.74818 12.4323 6.80711 11.6424 7.58594C10.8525 8.36477 9.78733 8.80066 8.67805 8.79899C7.57505 8.79953 6.51681 8.36283 5.73519 7.58458C4.95356 6.80633 4.51229 5.74998 4.50806 4.64699"
        />
      </svg>
    </Wrapper>
  );
};

UnknownGenderIcon.propTypes = {
  className: PropTypes.string,
  percentage: PropTypes.number,
};

export default UnknownGenderIcon;
